import React from "react";

export const HorizontalRule = () => {
  return <hr className="mx-2 my-8 h-[max(0.55vh,3px)] rounded-xxl border-slate-300 bg-slate-300 md:my-12" />;
};
